module.exports = __webpack_public_path__ + "static/bano-0a89aec2e2626ae61bb6834b6a369576.webp";